<template>
  <div class="list-page">
    <div class="con-head">
        <i class="icon-close" @click="close"></i>
        <h1>顺丰券</h1>
    </div>
    <div class="tip">
        <strong>顺丰线上电子优惠券信息，请登录[顺丰速运]公众号查询！</strong>
    </div>
    <div class="list-item">
      <router-view></router-view>
    </div>
    <p class="toFail" @click="showOverdueList" v-show="showToFail">查看失效券</p>

  </div>
</template>

<script>
import { log } from "util";
import Heade from "./heade";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      showToFail: true,
      type:1
    };
  },
  props: {
    //是否隐藏头部
    noHead: {
      type: String,
      default: "true"
    }
  },
  components: {
    Heade
  },
  created() {
		this.setShowHeader(this.noHead!=="true");
    this.showGeneralList();
  },
  methods: {
		...mapMutations({setShowHeader:'setShowHeader'}),
    // 通用卷
    showGeneralList() {
      this.type = 1;
      this.showToFail = true;
      this.$router.push({ name: "general" });
    },
    // 失效卷 
    showOverdueList() {
      this.type = 2;
      this.showToFail = false;
      this.$router.push({ name: "overdueg" });
    },
    close(){
      if( this.type === 2){
        this.showGeneralList();
      } else {
        this.$router.push({ name: "couponslogin" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.list-page {
  overflow: hidden;
  padding: 0 0.18rem;
  .tip {
    margin-top: 1.06rem;
    margin-bottom: 0.06rem;
    padding-left: 0.08rem;
    strong {
      font-size: 0.23rem;
    }
  }
  .toFail {
    font-size: 26px;
    color: #09f;
    margin-top: 0.38rem;
    text-align: center;
  }
    .con-head{
        width :100%;
        max-width: 750px;
        background-color: #f2f2f2;
        text-align: center;
        height: .88rem;
        line-height: .88rem;
        position: fixed;
        margin-left: -0.18rem;
        z-index: 90;
        h1{
            font-size:34px;
            color:#000;
            font-weight:bold;
        }
        .icon-close{
            width: 48px;
            height: 48px;
            position: absolute;
            background: url("../../assets/images/coupons/clear_24px2x.png") center no-repeat;
            background-size: cover;
            top: .20rem;
            left: .42rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/coupons/coupons-list.vue